import resetFilters from "./resetFilters"
import trackDownloads from "./trackDownloads"

$(function () {
  resetFilters();
  trackDownloads();
});
